import { BasicControl, CURSOR_TYPE, CommandGroup, DYMODE_MODE, LineT, Listeners, ModelBase, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { PYTHA_CTRL_TYPE } from "../enums/control-type";
import { MonixEraseCommand } from "../commands/MonixEraseCommand";


export class MonixEraseControl extends BasicControl {

    id: number = PYTHA_CTRL_TYPE.PYTHA_ERASE;
    step: number = 1;
    selectedEntities: ModelBase[] = [];

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    constructor(editor: ViewEditor, listeners: Listeners, isSubClass: boolean = false) {
        super();
        if (isSubClass) return;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.listeners.signals.needCapture.dispatch();
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = true;
        this.editor.clampControl.enabled = false;
        this.editor.clampControl.hidden = true;

        this.selectedEntities = this.editor.selectControl.getSelectedEntityList().filter(entity => !entity.lock);
        if (this.selectedEntities.length === 0) {
            this.extraContext.dymodeContext.setMode(DYMODE_MODE.TIPONLY)
            this.extraContext.dymodeContext.setDymodeTip('选择对象:');
            this.extraContext.stmodeContext.setStmode('选择对象', []);
            this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK);
        } else {
            this.isSingleUse = true;
            this.prevStep();
            this.dispose();
        }
        console.log('MonixEraseControl added')
    }

    dispose(): void {
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.noNeedCapture.dispatch();
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        console.log('MonixEraseControl removed')
    }


    _dymodeActive = false;


    prevStep = () => {
        this.extraContext.stmodeContext.pushLog(`_ERASE 找到${this.selectedEntities.length}个`);
        let command = new CommandGroup();
        command.cmds.push(new MonixEraseCommand(this.selectedEntities));
        this.editor.history.execute(command);
        this.listeners.signals.needRender.dispatch();
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.editor.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    pushEleWhenNotExist = (entities: ModelBase[], entity: LineT) => {
        const index = entities?.findIndex(element => element.uuid === entity.uuid);
        if (index === -1) {
            entities.push(entity);
        }
        return entities;
    }

    onKeyMouseConfirm = () => {
        if (this.step === 1) {
            this.selectedEntities = this.editor.selectControl.getSelectedEntityList().filter(entity => !entity.lock);

            if (this.selectedEntities.length == 0) {
                this.extraContext.stmodeContext.pushLog(`_ERASE 找到0个`);
                this.listeners.signals.emptySelectedEntities.dispatch();
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            } else {
                this.prevStep()
            }
        }
    }
}